// Central configuration for public trust indicators.
// Update these values only when official Etsy shop numbers are refreshed.
// Sourced from https://myguardpod.etsy.com (last refresh: 30 July 2026)
// Use rounded "public" figures ("1,200+" / "175+") to keep the site fresh
// between manual updates, per marketing policy.

export const ETSY_SHOP_URL = 'https://myguardpod.etsy.com';

export const TRUST_STATS = {
  en: {
    sales: {
      value: '1,200+',
      label: 'Etsy sales',
    },
    rating: {
      value: '4.9',
      suffix: '/5',
      label: 'average Etsy rating',
    },
    reviews: {
      value: '175+',
      label: 'Etsy reviews',
    },
    listings: {
      value: '30+',
      label: 'active product listings',
    },
    sourceNote: 'Verified activity from the MyGuardPod Etsy shop \u2014 last updated 30 July 2026.',
    linkLabel: 'View live shop activity on Etsy (opens in a new tab)',
  },
  fr: {
    sales: {
      value: 'Plus de 1\u202f200',
      label: 'ventes sur Etsy',
    },
    rating: {
      value: '4,9',
      suffix: '/5',
      label: 'note moyenne sur Etsy',
    },
    reviews: {
      value: 'Plus de 175',
      label: 'avis sur Etsy',
    },
    listings: {
      value: 'Plus de 30',
      label: 'fiches produits actives',
    },
    sourceNote: 'Activit\u00e9 v\u00e9rifi\u00e9e depuis la boutique Etsy MyGuardPod \u2014 mise \u00e0 jour du 30 juillet 2026.',
    linkLabel: 'Voir l\u2019activit\u00e9 en direct sur Etsy (ouvre dans un nouvel onglet)',
  },
};

export const getTrustStats = (language, live) => {
  const base = TRUST_STATS[language === 'fr' ? 'fr' : 'en'];
  if (!live?.shop) return base;
  const fr = language === 'fr';
  const locale = fr ? 'fr-CA' : 'en-US';
  const { shop, fetched_at } = live;
  const fmt = (n) => n.toLocaleString(locale);
  const ratingUp = (n) => (Math.min(5, Math.ceil(n * 10) / 10)).toFixed(1).replace('.', fr ? ',' : '.');
  const date = fetched_at
    ? new Date(fetched_at).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' })
    : null;
  return {
    ...base,
    live: true,
    sales: { ...base.sales, value: shop.transaction_sold_count ? fmt(shop.transaction_sold_count) : base.sales.value },
    rating: { ...base.rating, value: shop.review_average ? ratingUp(shop.review_average) : base.rating.value },
    reviews: { ...base.reviews, value: shop.review_count ? fmt(shop.review_count) : base.reviews.value },
    listings: { ...base.listings, value: shop.listing_active_count ? fmt(shop.listing_active_count) : base.listings.value },
    sourceNote: fr
      ? `Chiffres en direct de la boutique Etsy MyGuardPod${date ? ` \u2014 mis \u00e0 jour le ${date}` : ''}.`
      : `Live figures from the MyGuardPod Etsy shop${date ? ` \u2014 updated ${date}` : ''}.`,
  };
};
